// removed by extract-text-webpack-plugin
module.exports = {"descriptionBlock":"SRiv0Fms2ZM7mA6h0DV8u","descriptionTitle":"_2Xl8BfIOT9VjQ5dwKTAcov","descriptionList":"_3nObvw4SC4CWMpCTRicjF0","columnWrapper":"_3IbeQsfWJsFBZt88B2NkoV","descriptionItem":"CwT4F-Li3ocvKaMBLvFXV","realEstateBlock":"d4A8yeHO8CD0Wnk3TsK9Y","title":"_1rOpHeDxHaaE7sPkF3pR0S"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SiteDescription/SiteDescription.scss
// module id = 1783
// module chunks = 0